export default __webpack_public_path__ + "static/media/pink-deck.4ef907ba.svg";